module.exports = __webpack_public_path__ + "a887266d58189e4c736a96bdfa1f8ccd.MP3";